"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createMockStore = createMockStore;

var _redux = require("redux");

var _whereabouts = require("@rexlabs/whereabouts");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _index = require("../index");

function createMockStore(entities) {
  return (0, _redux.createStore)((0, _redux.combineReducers)({
    whereabouts: _whereabouts.whereaboutsReducer,
    // @ts-ignore
    entities: (0, _index.combineModels)('entities', entities)
  }), // @ts-ignore
  (0, _redux.applyMiddleware)(_whereabouts.whereaboutsMiddleware, _reduxThunk.default));
}